import ContactFloatingButton from './ContactFloatingButton'

export default function SkillsRobot() {
  return (
    <div>
      {/* 로봇 - 사용자가 로봇을 쉽고 ~ */}
      <div className='container mx-auto bg-sk-white max-md:px-20'>
        <div className='flex items-start justify-between py-48 sm:py-64 sm:items-center max-sm:flex-col sm:flex max-sm:gap-12'>
          <div className='flex flex-col items-start gap-6'>
            <p className='text-h2-medium sm:text-h1-medium text-sk-info'>로봇</p>
            <p className='text-title3-bold lg:text-title2-bold 2xl:text-title1-bold text-sk-default'>
              사용자가 로봇을 쉽고 직관적으로 제어하고, <br className='hidden sm:block' />
              로봇의 상태를 실시간으로 모니터링할 수 있습니다
            </p>
          </div>
          <p className='text-body1-long-medium text-sk-sub'>
            사용자는 로봇의 동작, 상태, 피드백을 시각적이거나 청각적인 방식으로{' '}
            <br className='hidden sm:block' />
            직관적으로 이해할 수 있으며, 명령 입력도 쉽게 할 수 있습니다
          </p>
        </div>
      </div>
      {/* 사례 */}
      <div className='container flex items-start justify-center gap-40 mx-auto py-60 sm:py-80 bg-sk-white mb-[-220px] sm:mb-[-260px] max-md:px-20 max-sm:flex-col'>
        <div className='flex flex-col items-start gap-32'>
          <img src={require('assets/images/skills-robot_ex1.png')} alt='' />
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body1-medium sm:text-h2-medium text-sk-info'>고객 사례</p>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                AI 성경 로봇
              </p>
            </div>
            <p className='text-body1-medium sm:text-h2-medium text-sk-default'>
              디바이스에 구애 받지 않고 하나의 데이터를 자연스럽게{' '}
              <br className='hidden 2xs:block' />
              연결한 모바일 앱 구현이 가능합니다
            </p>
          </div>
        </div>
        <div className='flex flex-col items-start gap-32'>
          <img src={require('assets/images/skills-robot_ex2.png')} alt='' />
          <div className='flex flex-col items-start gap-16'>
            <div className='flex flex-col items-start gap-4'>
              <p className='text-body1-medium sm:text-h2-medium text-sk-info'>고객 사례</p>
              <p className='text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold text-sk-default'>
                실시간 길찾기 로봇
              </p>
            </div>
            <p className='text-body1-medium sm:text-h2-medium text-sk-default'>
              실시간 길찾기 로봇은 내장된 센서, 지도 데이터, 인공지능 기술을 이용해{' '}
              <br className='hidden sm:block' />
              실시간으로 경로를 탐색하고 목적지까지의 길을 자동으로 찾는 자율 주행 로봇입니다
            </p>
          </div>
        </div>
      </div>
      <ContactFloatingButton />
    </div>
  )
}
